module.exports = __webpack_public_path__ + "explore/images/eoy/top-publishers/av-club-2x.f52f595701c397997543d808badb2aef.png";